import styled from 'styled-components';

export const Footer = styled.footer`
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.xl} ${theme.spacing.lg}`};
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;
